import { motion } from "framer-motion";
import { Eyebrow } from "./Reveal";

// headline: array where a {accent:true} part renders in serif accent
export const PageHeader = ({ eyebrow, title, accent, sub, testid = "page-header" }) => (
  <header className="pt-40 md:pt-52 pb-16 md:pb-24 max-w-7xl mx-auto px-6 md:px-12" data-testid={testid}>
    <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95] text-[#2E1B16] max-w-4xl">
        {title} {accent && <span className="font-accent font-normal text-[#38BDF8]">{accent}</span>}
      </h1>
      {sub && <p className="mt-7 text-lg md:text-xl text-[#2E1B16]/60 max-w-xl leading-relaxed">{sub}</p>}
    </motion.div>
  </header>
);

export default PageHeader;
